import React, { Component } from "react";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import { states } from "../../../../reducers/queriesStates";
import Preloader from "../../../../shared/items/static/preloader";
import MonitoringsTaskTripsItem from "./MonitoringsTaskTripsItem";
import { withSignalR } from "../../../../shared/containers/containerSignalR";
import { HubConnectionState } from "@microsoft/signalr";
import { withCars } from "../../../../shared/containers/containerCars";
import Notification from "../../../../shared/items/static/notification";

const CONNECTION_TIMER = 60000;
let handleConnectLastState;
let handleStartConnection;
let handleAddUserToGroup;

class MonitoringsTaskTripsList extends Component {
  componentDidMount() {
    const {
      dataConnectionStateSR,
      connectionSR,
      dataStateUnits,
      onConnectLastState,
      onStartConnection,
      dataStartConnectionStateSR,
    } = this.props;

    //connect if never connection
    if (dataConnectionStateSR !== states.READY && dataStateUnits === states.READY) {
      onConnectLastState();
    }

    //start connection if app has connected yet
    if (
      dataStartConnectionStateSR === states.NOT_REQUESTED &&
      dataConnectionStateSR === states.READY &&
      dataStateUnits === states.READY &&
      !!connectionSR &&
      connectionSR.connectionState === HubConnectionState.Disconnected
    ) {
      onStartConnection(connectionSR);
    }
  }

  componentWillUnmount() {
    const { onStopConnect, connectionSR } = this.props;

    if (!!connectionSR) {
      onStopConnect(connectionSR);
    }

    clearTimeout(handleConnectLastState);
    clearTimeout(handleStartConnection);
    clearTimeout(handleAddUserToGroup);
  }

  componentDidUpdate(prevProps) {
    const {
      dataStateUnits,
      dataConnectionStateSR,
      connectionSR,
      dataStartConnectionStateSR,
      dataUserGroupStateSR,
      dataRecieveUnitsLastStateSR,
      onStartConnection,
      onAddUserToGroup,
      onHandleRecieveUnitsLastState,
      onConnectLastState,
    } = this.props;

    //connect if never connection
    if (dataConnectionStateSR === states.NOT_REQUESTED && dataStateUnits === states.READY) {
      onConnectLastState();
    }

    // repeat connection if previous was a failure or closed
    if (dataConnectionStateSR === states.FAILURE && prevProps.dataConnectionStateSR !== states.FAILURE) {
      handleConnectLastState = setTimeout(() => {
        onConnectLastState();
      }, CONNECTION_TIMER);
    }

    // connect if previous connection was stopped
    if (
      dataStartConnectionStateSR === states.NOT_REQUESTED &&
      prevProps.dataStartConnectionStateSR !== states.NOT_REQUESTED &&
      dataConnectionStateSR === states.READY &&
      connectionSR.connectionState === HubConnectionState.Disconnected
    ) {
      onStartConnection(connectionSR);
    }

    // reconnect if connection is ready, but previous attempt to start was a failure
    if (
      dataStartConnectionStateSR === states.FAILURE &&
      prevProps.dataStartConnectionStateSR !== states.FAILURE &&
      dataConnectionStateSR === states.READY
    ) {
      handleStartConnection = setTimeout(() => {
        onStartConnection(connectionSR);
      }, CONNECTION_TIMER);
    }

    // connection is started, then add usergroup
    if (dataStartConnectionStateSR === states.READY && prevProps.dataStartConnectionStateSR !== states.READY) {
      onAddUserToGroup(connectionSR);
    }

    // repeat adding user to group if previous attempt was a failure
    if (dataUserGroupStateSR === states.FAILURE && prevProps.dataUserGroupStateSR !== states.FAILURE) {
      handleAddUserToGroup = setTimeout(() => {
        onAddUserToGroup(connectionSR);
      }, CONNECTION_TIMER);
    }

    // trigger to start recieve lastState
    if (
      dataConnectionStateSR === states.READY &&
      dataStartConnectionStateSR === states.READY &&
      dataUserGroupStateSR === states.READY &&
      dataRecieveUnitsLastStateSR === states.NOT_REQUESTED
    ) {
      onHandleRecieveUnitsLastState(connectionSR);
    }
  }

  render() {
    const { monitoringTaskTrips, monitoringTaskTripsDataState } = this.props;

    if (monitoringTaskTripsDataState === states.REQUEST) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    if (monitoringTaskTripsDataState === states.READY && monitoringTaskTrips.length === 0) {
      return (
        <Notification type="warning">
          <p>По данным параметрам поиска выполняемые рейсы не найдены.</p>
        </Notification>
      );
    }

    return (
      <div>
        {monitoringTaskTrips.map((item) => {
          return <MonitoringsTaskTripsItem key={item.id} item={item} />;
        })}
      </div>
    );
  }
}

export default withSignalR(withCars(withMonitoringTaskTrips(React.memo(MonitoringsTaskTripsList))));
